module.exports = __webpack_public_path__ + "img/ewm.ddb858c5.png";